import React, { useState } from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { shareRequest, listOrgMembers } from '../api';

// Share a request with a teammate in the same client organization. Solo users
// (no org) see nothing to share with.
export default function ShareRequest({ requestId }) {
  const [userId, setUserId] = useState('');
  const { data } = useQuery({ queryKey: ['training-org-members'], queryFn: listOrgMembers });
  const members = data?.members || [];
  const share = useMutation({
    mutationFn: () => shareRequest(requestId, userId),
    onSuccess: () => { toast.success('Shared'); setUserId(''); },
    onError: (e) => toast.error(e?.message || 'Failed'),
  });

  if (members.length === 0) {
    return <div className="mt-2 text-[11px] text-gray-400">No teammates in your organization to share with.</div>;
  }
  return (
    <div className="flex gap-2 mt-2">
      <select value={userId} onChange={(e) => setUserId(e.target.value)}
        className="flex-1 text-sm px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 dark:[&>option]:bg-gray-800">
        <option value="">Share with a teammate...</option>
        {members.map((m) => <option key={m.id} value={m.id}>{m.name || m.email}</option>)}
      </select>
      <button disabled={!userId || share.isPending} onClick={() => share.mutate()}
        className="text-sm px-3 py-2 rounded-lg bg-[#1f2a38] text-white disabled:opacity-40">Share</button>
    </div>
  );
}
